import { AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export type MemberInvitation = {
  email: string
  name: string
}

export type MemberInvitationResponse = {
  users: (MemberInvitation & { status: 'invited' | 'duplicated' | 'error' })[]
}
type MemberInvitationRequest = {
  companyId: number
  companyName: string
  users: (MemberInvitation & {
    role: 'admin' | 'owner' | 'member'
  })[]
}

export async function inviteMembers(
  payload: MemberInvitationRequest,
  config?: AxiosRequestConfig,
) {
  try {
    const { data } = await companiesApi.post<MemberInvitationResponse>(
      apiRoutes.inviteUser,
      payload,
      config,
    )

    return data.users
  } catch (e) {
    toast('Ocorreu um erro. Tente novamente mais tarde.', {
      type: 'info',
    })
  }

  return []
}
